/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Aboutpushtitle2Inputs */

const id_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang Notifikasi Push`)
};

const ms_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perihal Pemberitahuan Push`)
};

const da_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Push Notifikationer`)
};

const de_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Push-Benachrichtigungen`)
};

const en_us2_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Push Notifications`)
};

const es_es2_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de las notificaciones push`)
};

const es_mx2_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de las notificaciones push`)
};

const fil_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol sa Push Notifications`)
};

const fr_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos des notifications push`)
};

const it_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni sulle notifiche push`)
};

const hu_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A push értesítésekről`)
};

const nl_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over pushmeldingen`)
};

const no_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om push-varsler`)
};

const pl_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O powiadomieniach push`)
};

const pt_br2_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre notificações push`)
};

const pt_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre notificações push`)
};

const ro_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despre notificările push`)
};

const fi_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa push-ilmoituksista`)
};

const sv_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om push-notiser`)
};

const vi_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về thông báo đẩy`)
};

const tr_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Bildirimleri Hakkında`)
};

const cs_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O push oznámeních`)
};

const bg_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Относно push известията`)
};

const ru_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О push-уведомлениях`)
};

const uk_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про Push-сповіщення`)
};

const ar_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حول الإشعارات الفورية`)
};

const hi_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुश सूचनाओं के बारे में`)
};

const th_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับการแจ้งเตือนแบบพุช`)
};

const ja_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知について`)
};

const zh_cn2_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于推送通知`)
};

const zh_hant1_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於推播通知`)
};

const ko_notifications_aboutpushtitle2 = /** @type {(inputs: Notifications_Aboutpushtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시 알림 정보`)
};

/**
* | output |
* | --- |
* | "About Push Notifications" |
*
* @param {Notifications_Aboutpushtitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_aboutpushtitle2 = /** @type {((inputs?: Notifications_Aboutpushtitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Aboutpushtitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_aboutpushtitle2(inputs)
	if (locale === "ms") return ms_notifications_aboutpushtitle2(inputs)
	if (locale === "da") return da_notifications_aboutpushtitle2(inputs)
	if (locale === "de") return de_notifications_aboutpushtitle2(inputs)
	if (locale === "en-US") return en_us2_notifications_aboutpushtitle2(inputs)
	if (locale === "es-ES") return es_es2_notifications_aboutpushtitle2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_aboutpushtitle2(inputs)
	if (locale === "fil") return fil_notifications_aboutpushtitle2(inputs)
	if (locale === "fr") return fr_notifications_aboutpushtitle2(inputs)
	if (locale === "it") return it_notifications_aboutpushtitle2(inputs)
	if (locale === "hu") return hu_notifications_aboutpushtitle2(inputs)
	if (locale === "nl") return nl_notifications_aboutpushtitle2(inputs)
	if (locale === "no") return no_notifications_aboutpushtitle2(inputs)
	if (locale === "pl") return pl_notifications_aboutpushtitle2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_aboutpushtitle2(inputs)
	if (locale === "pt") return pt_notifications_aboutpushtitle2(inputs)
	if (locale === "ro") return ro_notifications_aboutpushtitle2(inputs)
	if (locale === "fi") return fi_notifications_aboutpushtitle2(inputs)
	if (locale === "sv") return sv_notifications_aboutpushtitle2(inputs)
	if (locale === "vi") return vi_notifications_aboutpushtitle2(inputs)
	if (locale === "tr") return tr_notifications_aboutpushtitle2(inputs)
	if (locale === "cs") return cs_notifications_aboutpushtitle2(inputs)
	if (locale === "bg") return bg_notifications_aboutpushtitle2(inputs)
	if (locale === "ru") return ru_notifications_aboutpushtitle2(inputs)
	if (locale === "uk") return uk_notifications_aboutpushtitle2(inputs)
	if (locale === "ar") return ar_notifications_aboutpushtitle2(inputs)
	if (locale === "hi") return hi_notifications_aboutpushtitle2(inputs)
	if (locale === "th") return th_notifications_aboutpushtitle2(inputs)
	if (locale === "ja") return ja_notifications_aboutpushtitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_aboutpushtitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_aboutpushtitle2(inputs)
	return ko_notifications_aboutpushtitle2(inputs)
});
export { notifications_aboutpushtitle2 as "notifications.aboutPushTitle" }